export default "__VITE_ASSET__DnxRY52D__"